import { initializeApp } from "@firebase/app";
import { firebaseConfig } from "src/constants/firebase";
// import { getAnalytics } from "firebase/analytics";

export const app = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(app);
